import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalInviteRestaurantEmployeeDocument = gql`
  mutation SalesPortalInviteRestaurantEmployee(
    $name: String!
    $restaurantUUID: uuid!
    $supplierUUID: uuid
    $contactInfo: ContactInfoInput!
    $employeeRole: String
  ) {
    inviteRestaurantEmployee(
      name: $name
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
      contact_info: $contactInfo
      employee_role: $employeeRole
    ) {
      employee_id
      is_duplicate_employee
    }
  }
`;
export type SalesPortalInviteRestaurantEmployeeMutationFn =
  Apollo.MutationFunction<
    Types.SalesPortalInviteRestaurantEmployeeMutation,
    Types.SalesPortalInviteRestaurantEmployeeMutationVariables
  >;
export function useSalesPortalInviteRestaurantEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalInviteRestaurantEmployeeMutation,
    Types.SalesPortalInviteRestaurantEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalInviteRestaurantEmployeeMutation,
    Types.SalesPortalInviteRestaurantEmployeeMutationVariables
  >(SalesPortalInviteRestaurantEmployeeDocument, options);
}
export type SalesPortalInviteRestaurantEmployeeMutationHookResult = ReturnType<
  typeof useSalesPortalInviteRestaurantEmployeeMutation
>;
export type SalesPortalInviteRestaurantEmployeeMutationResult =
  Apollo.MutationResult<Types.SalesPortalInviteRestaurantEmployeeMutation>;
export type SalesPortalInviteRestaurantEmployeeMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalInviteRestaurantEmployeeMutation,
    Types.SalesPortalInviteRestaurantEmployeeMutationVariables
  >;
